<div class="app-user-create content">
    <header class="sticky-header">
        <div class="left-column">
            <div class="icon-header">
                <div class="icon-container">
                    <mat-icon>person</mat-icon>
                </div>
                <h1 id="create-title" class="icon-header-title" data-automation="createTitle">
                    {{ 'user.create.page_title' | translate }}
                </h1>
            </div>
        </div>

        <div class="right-column">
            <button
                class="icon-btn x-btn-secondary"
                aria-label="Cancel"
                (click)="handleCancel()"
                data-automation="exitButton"
                [disabled]="userSubmitService.submittingUser$ | async"
            >
                <mat-icon>clear</mat-icon>
                <span class="btn-text">{{ 'user.button.exit' | translate }}</span>
            </button>
        </div>
    </header>

    <ng-container *ngIf="createdForm">
        <app-user-form [mode]="mode" [userForm]="userForm"></app-user-form>
    </ng-container>
</div>
